import { http } from '@/core/helpers/axiosHelper';
import { ApiResource } from '@/core/models/ApiResource.interface';
import { UserInfo } from './user-info.interface';

export class UserInfoService {
   async getUser() {
      return http.get<ApiResource<UserInfo>>('/user-info', { params: { embed: 'scopes,teams' } }).then((response) => response.data.data);
   }
   async patchUser(values: any) {
      return http
         .patch<ApiResource<UserInfo>>('/user-info', values, { params: { embed: 'scopes,teams' } })
         .then((response) => response.data.data);
   }
}
